// src/pages/ExtraOrder.tsx
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { postReOrder } from '../utils/api'; // API utility
import { CartItem } from '../utils/types';
import ProductOptionsModal from '../components/ProductOptionsModal';
import { useSettings } from '../context/SettingsContext';
import { fetchOrderDetails } from '../utils/api';
import { OrderSummary } from '../utils/types';
import { FaArrowLeftLong } from "react-icons/fa6";

const ExtraOrder: React.FC = () => {
    const { settings } = useSettings();

    const { cartItems, clearCart } = useCart();
    const location = useLocation();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedCartItem, setSelectedCartItem] = useState<CartItem | null>(null);

    const queryParams = new URLSearchParams(location.search);
    const orderId: any = queryParams.get('order_id'); // Extract order_id from the URL
    const vendorId = JSON.parse(localStorage.getItem('user') || '').vendor_id; // Get vendor ID
    const token = localStorage.getItem('token');

    const [order, setOrder] = useState<OrderSummary | null>(null);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        const fetchOrder = async () => {
            try {
                if (settings && orderId) {
                    const orderDetails = await fetchOrderDetails(settings.vendorId, orderId);
                    console.log('orderDetails page: ', orderDetails);
                    setOrder(orderDetails);
                }
            } catch (error) {
                console.error("Error fetching order details:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchOrder();
    }, [settings, orderId]);

    const handleAddOrder = async () => {
        if (!orderId) {
            alert('No order ID specified.');
            return;
        }

        setIsLoading(true);

        try {
            const payload = {
                amountToPay: cartItems.reduce((acc, item) => acc + item.totalPrice, 0),
                items: cartItems.map(item => ({
                    productId: item.productId,
                    quantity: item.quantity,
                    price: item.price,
                    options: item.options,
                })),
                status: 'Pending', // Default status
                orderType: localStorage.getItem('orderType') || 'Takeaway',
                tableId: localStorage.getItem('selectedTable') || null,
            };

            const response = await postReOrder(vendorId, orderId, payload, token);
console.log(response);
            if (response.status === 200) {
                alert('Order updated successfully!');
                clearCart(); // Clear the current cart
                navigate(`/cart?order_id=${orderId}`); // Redirect back to CartPage
            } else {
                alert('Failed to update the order.');
            }
        } catch (error) {
            console.error('Error updating order:', error);
            alert('An error occurred while updating the order.');
        } finally {
            setIsLoading(false);
        }
    };

    const handleEdit = (cartItem: CartItem) => {
        setSelectedCartItem(cartItem);
        setModalOpen(true);
    };

    const handleCloseModal = () => {
        setModalOpen(false);
        setSelectedCartItem(null);
    };

    return (
        <div className="app-page">
            <h2 className="text-lg font-semibold">Extra Order</h2>
            <div>{order &&
                <p>Order ID: {order.id}</p>
            }</div>

            {cartItems.length === 0 ? (
                <p>Your cart is empty.</p>
            ) : (
                <ul>
                    {cartItems.map((item) => (
                        <li key={item.productKey} className="border-b py-2">
                            <h4 className="text-sm font-semibold">
                                {item.name} - {item.quantity} x {item.price}
                            </h4>
                            <button
                                className="text-blue-500 underline"
                                onClick={() => handleEdit(item)}
                            >
                                Edit
                            </button>
                        </li>
                    ))}
                </ul>
            )}

            <button
                onClick={handleAddOrder}
                className="btn btn-primary mt-4"
                disabled={isLoading || cartItems.length === 0}
            >
                {isLoading ? 'Updating Order...' : 'Add to Existing Order'}
            </button>

            {/* Reuse ProductOptionsModal for editing */}
            {modalOpen && selectedCartItem && (
                <ProductOptionsModal
                    product={selectedCartItem.product} // Pass the entire product object
                    vendorId={selectedCartItem.vendorId} // Pass the vendorId from the selected cart item
                    isOpen={modalOpen}
                    onClose={handleCloseModal}
                    initialQuantity={selectedCartItem.quantity}
                    cartItem={selectedCartItem} // Pass the cart item to modal for editing
                    isEditMode={true} // Enable edit mode in modal
                    fromCart={false} // Enable edit mode if from Cart

                />
            )}
        </div>
    );
};

export default ExtraOrder;
